tippy('[data-tippy-template]', {
    content(reference) {
        const id = reference.getAttribute('data-tippy-template');
        const template = document.getElementById(id);
        return template.innerHTML;
    },
    allowHTML: true,
    interactive: true,
    interactiveBorder: 30,
    interactiveDebounce: 75,
    placement: getTippyPlacement(),
    theme: 'psgamer',
    appendTo: () => document.body,
    maxWidth: 380,
});

tippy('[data-tippy-content]', {
});

function getTippyPlacement() {
    let position = 'right';
    if($(window).width() < 768){
        position = 'bottom';
    }
    return position;
}